<template>
  <div class="d-flex flex-column">
    <subnav
      :links="subnav"
      :heading="`Автомат ${serial_number}`"
      :show-links="!!serial_number"
    />
    <div class="flex-grow-1 position-relative">
      <div class="overflow-content">
        <transition name="fade" mode="out-in">
          <router-view :id="id" :machine="machine" v-if="machine"></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    metaInfo () {
      return {title: `Автомат ${this.serial_number}`}
    },
    props: {
      // machine id, comes from route
      id: {
        required: true,
      },
    },
    data () {
      return {
        subnav: [
          {
            text: 'Общее',
            to: `/machines/${this.id}`,
            exact: true,
            permission: 'web_ta_main',
          },
          {
            text: 'Денежные средства',
            to: `/machines/${this.id}/money`,
            permission: 'web_ta_money',
          },
          {
            text: 'Матрица',
            to: `/machines/${this.id}/matrix`,
            permission: 'web_ta_matrix',
          },
          {
            text: 'Модем',
            to: `/machines/${this.id}/modem`,
            permission: 'web_ta_modem',
          },
          {
            text: 'Режим работы',
            to: `/machines/${this.id}/schedule`,
            permission: 'web_ta_schedule',
          },
          {
            text: 'Магнитные карты',
            to: `/machines/${this.id}/cards`,
            permission: 'web_ta_magnet',
          },
          {
            text: 'EVA-DTS',
            to: `/machines/${this.id}/eva`,
            permission: 'web_ta_eva',
          },
          {
            text: 'Доотправка чеков',
            to: `/machines/${this.id}/matrixSendReceipts`,
            permission: 'web_matrix_send_receipts',
          },
        ],
      }
    },
    computed: {
      serial_number () {
        return (this.machine && this.machine.serial_number) || this.$root.store.serial_number || ''
      },
    },
    asyncComputed: {
      machine () {
        return api
          .get(`machines/${this.id}`)
          .then(({data}) => data.data)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/machines/_id.vue